export interface CardInterface {
    rank: string
    suit: string
    key: string
}

const ranks = '2 3 4 5 6 7 8 9 10 J Q K A'.split(' ')

class Card implements CardInterface {
    public readonly rank: string
    public readonly suit: string
    public readonly key: string

    constructor(rank: string, suit: string) {
        this.rank = rank
        this.suit = suit
        this.key = rank + suit
    }

    public weight(trump?: Card): number {
        let weight = ranks.indexOf(this.rank) + 2

        if (trump && trump.suit === this.suit) {
            weight += 100
        }
        return weight
    }

    public toJSON(): object {
        return {rank: this.rank, suit: this.suit}
    }
}

export {Card}
